/**
 * Suite auth: validate JWT from AMGS Suite so users can land on Sales Hub without re-entering credentials.
 * Suite sends users to /auth/suite?suite_token=JWT&login_hint=email
 */

const getSuiteApiUrl = () => {
  const url = process.env.REACT_APP_SUITE_API_URL || 'http://localhost:3001';
  return url.replace(/\/$/, '');
};

/**
 * Validate the suite token with the Suite backend.
 * @param {string} suiteToken - JWT from Suite (suite_token query param)
 * @returns {Promise<{ valid: true, payload: object } | { valid: false }>}
 */
export const validateSuiteToken = async (suiteToken) => {
  if (!suiteToken || typeof suiteToken !== 'string') {
    return { valid: false };
  }
  const baseUrl = getSuiteApiUrl();
  const validateUrl = `${baseUrl}/api/auth/validate`;
  try {
    const res = await fetch(validateUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${suiteToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (!res.ok) {
      return { valid: false };
    }
    const data = await res.json();
    // Expect 200 JSON with payload (e.g. { email, sub, name, role })
    const payload = data.payload ?? data;
    return { valid: true, payload };
  } catch (err) {
    console.error('Suite token validation failed:', err);
    return { valid: false };
  }
};

export { getSuiteApiUrl };
